module.exports = __webpack_public_path__ + "static/media/E2.48dbd796.jpeg";